module.exports = __webpack_public_path__ + "static/we-walk-by-faith-5e99b5b76ecdeeadc252240f6d32bc35.jpg";